import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, IconButton } from '@skatteetaten/ds-buttons';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { FileOutlineSVGpath, CheckIcon, FileOutlineIcon, CancelSVGpath } from '@skatteetaten/ds-icons';
import { Spinner } from '@skatteetaten/ds-progress';
import './styles.css';


var styles = {
    "successIcon": "FileUploaderFile-module_successIcon__SzUfz",
    "successIconLinkMargin": "FileUploaderFile-module_successIconLinkMargin__xYf40",
    "cancelIcon": "FileUploaderFile-module_cancelIcon__34vSn",
    "fileSpinner": "FileUploaderFile-module_fileSpinner__VewIT",
    "fileListItem": "FileUploaderFile-module_fileListItem__uUnN-",
    "fileListGrid": "FileUploaderFile-module_fileListGrid__Ro2qk",
    "fileListText": "FileUploaderFile-module_fileListText__0Do0V",
    "fileListIcon": "FileUploaderFile-module_fileListIcon__AcG1d",
    "fileListContainer": "FileUploaderFile-module_fileListContainer__Qpenu",
    "fileListLink": "FileUploaderFile-module_fileListLink__Z4S40",
    "fileListFile": "FileUploaderFile-module_fileListFile__IreJz"};

const FileUploaderFile = /*#__PURE__*/ forwardRef(({ id: externalId, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, fileIconTitle, href, successIconTitle, showSpinner, onClick, onClickDelete, children }, ref)=>{
    const { t } = useTranslation('ds_forms', {
        i18n: dsI18n
    });
    const generatedId = useId();
    const id = externalId ?? generatedId;
    return /*#__PURE__*/ jsx("li", {
        ref: ref,
        id: id,
        className: `${styles.fileListItem} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        children: /*#__PURE__*/ jsxs("div", {
            className: styles.fileListContainer,
            children: [
                /*#__PURE__*/ jsxs("span", {
                    className: styles.fileListGrid,
                    children: [
                        href ? /*#__PURE__*/ jsxs(Fragment, {
                            children: [
                                /*#__PURE__*/ jsx(Link, {
                                    id: `${id}-file-${children}`,
                                    svgPath: FileOutlineSVGpath,
                                    href: href,
                                    className: `${styles.fileListText} ${styles.fileListLink}`,
                                    download: true,
                                    onClick: onClick,
                                    children: children
                                }),
                                /*#__PURE__*/ jsx(CheckIcon, {
                                    className: `${styles.successIcon} ${styles.successIconLinkMargin}`,
                                    size: 'medium',
                                    title: successIconTitle ?? t('fileuploader.SuccessIconLabel')
                                })
                            ]
                        }) : /*#__PURE__*/ jsxs("span", {
                            className: styles.fileListText,
                            children: [
                                /*#__PURE__*/ jsx(FileOutlineIcon, {
                                    className: styles.fileListIcon,
                                    size: 'small',
                                    title: fileIconTitle ?? t('fileuploader.FileIconLabel')
                                }),
                                /*#__PURE__*/ jsx("span", {
                                    id: `${id}-file-${children}`,
                                    className: styles.fileListFile,
                                    children: children
                                }),
                                /*#__PURE__*/ jsx(CheckIcon, {
                                    className: styles.successIcon,
                                    size: 'medium',
                                    title: successIconTitle ?? t('fileuploader.SuccessIconLabel')
                                })
                            ]
                        }),
                        showSpinner && /*#__PURE__*/ jsx(Spinner, {
                            className: styles.fileSpinner,
                            color: 'blue',
                            size: 'medium',
                            hideTitle: true,
                            children: t('fileuploader.DeleteInProgress')
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("span", {
                    children: /*#__PURE__*/ jsx(IconButton, {
                        svgPath: CancelSVGpath,
                        className: styles.cancelIcon,
                        title: t('fileuploader.DeleteLabel'),
                        ariaDescribedby: `${id}-file-${children}`,
                        onClick: onClickDelete
                    })
                })
            ]
        })
    });
});
FileUploaderFile.displayName = 'FileUploaderFile';

export { FileUploaderFile };
